import { CommandListDiscrepancies } from "./commands/cmdListDiscrepancies";
import { CommandGetDiscrepancy } from "./commands/cmdGetDiscrepancy";
import { CommandGetMissingMembers } from "./commands/cmdGetMissingMembers";
import { CommandReportDiscrepancy } from "./commands/cmdReportDiscrepancy";
import { CommandAcceptDiscrepancy } from "./commands/cmdAcceptDiscrepancy";
import { CommandPickPeople } from "./commands/cmdPickPeople";
import { CommandAddCorrection } from "./commands/cmdAddCorrection";
import { CommandPreviewCorrection } from "./commands/cmdPreviewCorrection";
import { CommandListCorrections } from "./commands/cmdListCorrections";
import { CommandRevokeCorrection } from "./commands/cmdRevokeCorrection";
import { CommandEditCorrectionPeople } from "./commands/cmdEditCorrectionPeople";
import { CommandListDiscrepancyFiles } from "./commands/cmdListDiscrepancyFiles";
import { CommandListCorrectionFields } from "./commands/cmdListCorrectionFields";
import type {
  AddCorrectionPayload,
  DiscrepancyStatus,
  PeopleSelection,
  ReportDiscrepancyPayload,
} from "@models/Discrepancy.model";

export class DiscrepancyService {
  async list(filters: { status?: DiscrepancyStatus; populationSegmentId?: number } = {}) {
    return new CommandListDiscrepancies().run(filters);
  }

  async get(id: number) {
    return new CommandGetDiscrepancy().run(id);
  }

  async missingMembers(id: number) {
    return new CommandGetMissingMembers().run(id);
  }

  async report(payload: ReportDiscrepancyPayload) {
    return new CommandReportDiscrepancy().run(payload);
  }

  async accept(id: number, note: string) {
    return new CommandAcceptDiscrepancy().run(id, note);
  }

  async pickPeople(id: number, selection: PeopleSelection) {
    return new CommandPickPeople().run(id, selection);
  }

  async previewCorrection(id: number, payload: AddCorrectionPayload) {
    return new CommandPreviewCorrection().run(id, payload);
  }

  async addCorrection(id: number, payload: AddCorrectionPayload) {
    return new CommandAddCorrection().run(id, payload);
  }

  async corrections(scope: { discrepancyId?: number; populationSegmentId?: number }) {
    return new CommandListCorrections().run(scope);
  }

  async revokeCorrection(correctionId: number) {
    return new CommandRevokeCorrection().run(correctionId);
  }

  async editCorrectionPeople(correctionId: number, selection: PeopleSelection) {
    return new CommandEditCorrectionPeople().run(correctionId, selection);
  }

  async files(id: number) {
    return new CommandListDiscrepancyFiles().run(id);
  }

  async fields(id: number) {
    return new CommandListCorrectionFields().run(id);
  }
}
